// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"78848c7c","448":"140664ed","726":"63e59fed","833":"19979088"}[chunkId] + ".chunk.js";
};